import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

@Module({
  name: 'filter',
  namespaced: true
})
export class FilterStore extends VuexModule {
  lngLat: [number, number] | null = null;

  @Mutation
  add(lngLat: [number, number]) {
    this.lngLat = lngLat;
  }

  @Mutation
  remove() {
    this.lngLat = null;
  }
}
